<template>
  <div>
    <v-menu offset-y rounded="xl" v-model="isMenuOpen" :close-on-content-click="false" @input="resetPanels">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ma-2" v-bind="attrs" v-on="on" color="#E5E5E5" outlined>
          <v-icon color="primary" class="mr-2">ph ph-funnel-simple</v-icon>
          <span class="primary--text font-weight-bold">Filtro</span>
        </v-btn>
      </template>
      <v-card class="card">
        <v-row class="pa-2 pb-0">
          <v-col cols="8">
            <span class="text-title">Filtro avançado</span>
          </v-col>
          <v-col cols="4" class="d-flex justify-end">
            <v-icon color="#3A3939" @click="close">ph ph-x</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels v-model="activePanels" flat>
            <v-expansion-panel v-for="(item, i) in items" :key="i">
              <v-expansion-panel-header class="py-0">
                <span class="text-panel">{{ item.title }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid class="pa-0">
                  <v-checkbox class="ma-0" v-for="(option, p) in item.value" :key="p" v-model="selected[item.key]"
                    :value="option.value" :multiple="item.key !== 'DtAbertura'" hide-details
                    @change="handleCheckboxChange(item.key, option.value)" :input-value="selected[item.key] === option.value">
                    <template v-slot:label>
                      <div v-if="option.color" class="bullet" :style="`background-color: ${option.color}`"></div>
                      <span class="text-checkbox">{{ option.text }}</span>
                    </template>
                  </v-checkbox>
                  <v-row class="pa-0" v-if="item.key === 'DtAbertura'">
                    <v-col cols="6" class="pl-0">
                      <input-date label="Data de início" placeholder="00/00/0000" dense v-model="filtro.dataInicio" :min="dtaMin" />
                    </v-col>
                    <v-col cols="6" class="pr-0">
                      <input-date label="Data fim" placeholder="00/00/0000" dense v-model="filtro.dataTermino" :min="filtro.dataInicio" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row class="flex-row-reverse px-5 py-3">
          <v-btn color="primary" elevation="0" @click="Filtrar" :disabled="!hasSelectedFilters">Filtrar</v-btn>
          <v-btn color="#E5E5E5" elevation="0" class="mx-2" @click="clearFilters">Limpar filtros</v-btn>
        </v-row>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    filtro: {}
  },
  data () {
    return {
      selected: {},
      activePanels: [],
      isMenuOpen: false,
      dtaMin: this.$api.UI.Format.Date(this.$api.UI.Date.AddDay(new Date(), -180), 'yyyy-MM-dd'),
    };
  },
  computed: {
    items () {
      return [
        { id: 0, title: 'Por status', value: this.$aux.StatusContratacaoContas, key: 'Status' },
        { id: 1, title: 'Por tipo de conta', value: this.$api.Onboarding.TipoConta, key: 'TipoConta' },
        { id: 2, title: 'Por tipo de pessoa', value: this.$api.Onboarding.TipoPessoaFiltro, key: 'TipoPessoa' },
        { id: 3, title: 'Por data de abertura de conta', value: this.$api.Onboarding.PeriodoFiltro, key: 'DtAbertura' },
      ];
    },
    hasSelectedFilters () {
      const hasSelected = Object.values(this.selected).some(filters =>
        Array.isArray(filters) ? filters.length > 0 : filters
      );
      const hasDateFilters = this.filtro.dataInicio && this.filtro.dataTermino;
      return hasSelected || hasDateFilters;
    }
  },
  watch: {
    filtro: {
      deep: true,
      handler (newValue) {
        if (newValue.dataInicio || newValue.dataTermino) {
          this.selected.DtAbertura = [];
        }
      }
    },
  },
  methods: {
    handleCheckboxChange (key, value) {
      if (key === 'TipoConta' || key === 'TipoPessoa') {
        if (this.selected[key].length > 1) {
          const item = this.selected[key].indexOf(value)
          this.selected[key].splice(item, 1)
        }
      }
    },
    close () {
      this.isMenuOpen = false;
      this.activePanels = [];
    },
    clearFilters () {
      this.selected = {};
      this.initializeSelected();
      this.$emit('filtrar')
      this.close();
    },
    initializeSelected () {
      this.selected = {};
      this.items.forEach(item => {
        this.$set(this.selected, item.key, []);
      });
    },
    resetPanels () {
      this.activePanels = [];
    },
    async Filtrar () {
      const th = this;
      const params = {
        situacaoAnalise: th.selected.Status || null,
        modeloConta: th.selected.TipoConta || null,
        tipoPessoa: th.selected.TipoPessoa || null,
        dataInicio: th.filtro.dataInicio || null,
        dataFim: th.filtro.dataTermino || null
      };
      if (Number(th.selected.DtAbertura) > 0) {
        params.dataInicio = this.$api.UI.Format.Date(this.$api.UI.Date.AddDay(new Date(), -th.selected.DtAbertura), 'yyyy-MM-dd');
        params.dataFim = this.$api.UI.Format.Date(this.$api.UI.Date.AddDay(new Date()), 'yyyy-MM-dd');
      }
      th.$emit('filtrar', params)
      th.close();
    }
  },
};
</script>

<style scoped>
.card {
  border-radius: 16px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  width: 440px;
}

.text-title {
  color: #3A3939;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
}

.text-panel {
  color: #828282;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.text-checkbox {
  color: #3A3939;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
}
</style>
